const userInformationDefaultState = {
    shippingAddresses: undefined,
    acceptEmails: undefined,
    recentlyViewed: undefined,
}

export default (state = userInformationDefaultState, action) => {

    switch (action.type) {
        case "SET_SHIPPING_ADDRESSES":
            return {
                ...state,
                shippingAddresses: action.shippingAddresses,
            }
        case "SET_EMAIL_PREFERENCES":
            return {
                ...state,
                acceptEmails: action.acceptEmails
            }

        case "SET_RECENTLY_VIEWED":
            return {
                ...state,
                recentlyViewed: action.recentlyViewed
            }

        default:
            return state
    }
}
